import { differenceInCalendarDays, endOfMonth } from 'date-fns'

export const getDaysRemainingToEndOfMonth = (date: Date): number => {
  const end = endOfMonth(date)
  return differenceInCalendarDays(end, date)
}
